import {SelectionRequestJson, SimulationRequestJson} from "./ApiJsonTypes";

/**
 * Snapshots a concrete simulation request (a single fully-specified fan) as selection criteria,
 * so the mechanical configurator can export the same JSON format the fan selection screen uses.
 * The fixed fan flow specification (diameter, rpm, blade angle) becomes the requested preferences;
 * blade profile/count preferences are left unset because a specific fan is already chosen.
 */
export function simulationRequestToSelectionRequest(simulation: SimulationRequestJson): SelectionRequestJson {
    return {
        fanFlowPreferences: {
            requestedBladeAngle: simulation.fanFlowSpecification.bladeAngle,
            requestedFanDiameters: simulation.fanFlowSpecification.fanDiameters,
            requestedRpm: simulation.fanFlowSpecification.rpm,
            requestedBladeProfileNames: null,
            requestedBladeCounts: null,
            fluidSpecification: simulation.fanFlowSpecification.fluidSpecification,
        },
        fanWorkingPointQuery: simulation.fanWorkingPointQuery,
        installationWorkingPointQuery: simulation.installationWorkingPointQuery,
        installationSpecification: simulation.installationSpecification,
        mechanicalPreferences: simulation.mechanicalPreferences,
        manufacturingSpecification: simulation.manufacturingSpecification,
        softStartPresent: simulation.softStartPresent,
        realizeWithClutch: simulation.realizeWithClutch,
    };
}
